/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import Select from 'components/Select';
import {
  getDescuentosAcumulados,
} from 'api/nominas/descuentos/descuentosAcumulados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { checkToken } from 'api/utils';
import { getDescuentos } from 'api/nominas/descuentos/descuentos';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';

export const descuentosAcumuladosPermission = {
  permissionModel: 'descuentoempleadoacumulado',
  catalogsModels: [],
  tabsModels: [],
};

const DescuentoAcumulado = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState();
  const [descuentos, setDescuentos] = useState([]);
  const [descuentosEmpleados, setDescuentosEmpleados] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [empleado, setEmpleado] = useState();
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [descuento, setDescuento] = useState();
  const [descuentoEmpleado, setDescuentoEmpleado] = useState();

  const nameEmpleado = 'empleado';
  const namePuesto = 'puesto';
  const nameArea = 'area';
  const namePlaza = 'plaza';
  const getPlaza = (idEmpleado) => {
    const _datoOperacional = datosOperacionales?.find((e) => e.empleado === idEmpleado);
    const idPlaza = _datoOperacional?.plaza;
    return ({
      _plaza: plazas?.find((p) => p.id === idPlaza),
      _datoOp: _datoOperacional,
    });
  };
  const onChangeEmpleado = (empleadoId) => {
    const { _plaza } = getPlaza(empleadoId);

    // const tipoNominaInfo = _plaza?.tipo_nomina_empleado || '';
    const areaStr = _plaza?.directorio_area_clave_y_nombre || '';
    const plazaStr = _plaza?.clave_y_descripcion || '';
    const puestoStr = _plaza?.puesto_descripcion || '';
    // const tipoNomina = _datoOp?.tipo_de_nomina_empleado || null;

    const fieldsValues = {
      [namePlaza]: plazaStr,
      [namePuesto]: puestoStr,
      [nameArea]: areaStr,
    };
    setEmpleado(empleadoId);
    form.setFieldsValue(fieldsValues);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDescuentosAcumulados({
      empleado,
      descuento,
      descuento_empleado: descuentoEmpleado,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _plazas,
        _descuentos,
        _periodos,
        _periodosNominas,
        _datosOperacionales,
      ] = await Promise.all([
        getEmpleadosOptimized(),
        getPlazasvistaOptimized(),
        getConfiguracionDescuentos({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getDatoOperacionalesDeEmpleados(),
      ]);
      if (mounted) {
        setEmpleados(_empleados);
        setPlazas(_plazas);
        setPeriodos(_periodos.filter((periodosNomDetalle) => _periodosNominas.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
        setDatosOperacionales(_datosOperacionales);
        const _descuentosFiltered = _descuentos?.filter((e) => e.tipo_de_descuento !== 2);
        setDescuentos(_descuentosFiltered);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (empleado) {
      fetchData();
    }
  }, [descuento, descuentoEmpleado]);

  // const onChangeEmpleado = (value) => {
  //   const _empleado = empleados.find((e) => e.id === value);
  //   const _admin = adminPlazas.find((e) => e.empleado === _empleado?.id);
  //   const _plaza = plazas.find((e) => e.id === _admin?.plaza);
  //   const _puesto = puestos.find((e) => e.id === _plaza?.puesto);
  //   const _area = areaBuscar(_plaza?.area_content_id, areas);
  //   setPuesto(_puesto?.descripcion);
  //   setArea(_area?.title);
  //   setPlaza(_plaza?.clave);
  //   setEmpleado(value);
  //   form.resetFields(['descuento', 'descuento_empleado']);
  //   setData([]);
  // };

  const onChangeDescuento = (value) => {
    setDescuento(value);
    setDescuentoEmpleado();
    form.resetFields(['descuento_empleado']);
    getDescuentos({
      empleado,
      descuento: value,
    }).then((_data) => {
      setDescuentosEmpleados(_data?.results);
    });
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'descuento_empleado',
      key: 'descuento_empleado',
      width: 150,
      render: (val) => descuentosEmpleados?.find((e) => e.id === val)?.clave,
    },
    {
      titleText: 'No. de Nómina',
      dataIndex: 'numero_de_nomina',
      key: 'numero_de_nomina',
      width: 200,
    },
    {
      titleText: 'Periodo de Nómina',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 200,
      render: (val) => {
        const _periodo = periodos.find((e) => e.id === val);
        if (!_periodo) {
          return '';
        }
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial}-${_periodo?.fecha_final})`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Fecha de Retiro',
      dataIndex: 'fecha_de_retiro',
      key: 'fecha_de_retiro',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Retiro',
      dataIndex: 'retiro',
      key: 'retiro',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Acumulado',
      dataIndex: 'acumulado',
      key: 'acumulado',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
        >
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      name={nameEmpleado}
                      label="No. y Nombre del Empleado"
                      required
                      hasFeedback
                    >
                      <Select
                        labelProp="numero_y_nombre_completo"
                        dataSource={empleados}
                        onChange={onChangeEmpleado}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              {/* {selectedEmpleadoSearch
                ? (
                  form.setFieldsValue({
                    empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                  })
                ) : null} */}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={namePuesto}
                  label="Puesto"
                >
                  <Input
                    allowClear
                    disabled
                  // value={puesto}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={nameArea}
                  label="Área"
                >
                  <Input
                    allowClear
                    disabled
                  // value={area}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name={namePlaza}
                  label="Plaza"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled
                  // value={plaza}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descuento"
                  label="Concepto de Descuento"
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="concepto"
                    dataSource={descuentos}
                    onChange={onChangeDescuento}
                    render={(value) => `${value?.clave} - ${value?.concepto}`}
                    disabled={!empleado}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descuento_empleado"
                  label="Clave de Descuento"
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="clave"
                    dataSource={descuentosEmpleados}
                    onChange={(value) => setDescuentoEmpleado(value)}
                    disabled={!descuento}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            cols={columns}
            data={data}
            allowExportPDF={false}
          />
        </Card>
      </Spin>
    </Row>
  );
};

export default DescuentoAcumulado;
